import { setFormFieldValue } from "../../helpers/FormHelper";
import { CDN_TEAM_LOGO } from "../../services/FootballService";

export const initialState = {
    leagueId: null,
    season: null,
    fixture: null,
    homeTeam: null,
    awayTeam: null,
    homeForm: [],
    awayForm: [],
    homeFixtures: [],
    awayFixtures: [],
    standings: [],
    h2h: [],
    events: [],
    lineups: [],
    statistics: [],
    statisticPairs: null,
    isLoading: true,
    lastMatches: 5,
};


export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case 'set_fixture':
            const fixtureData = setFormFieldValue(action.payload);
            const leagueId = setFormFieldValue(fixtureData?.league?.id);
            const season = setFormFieldValue(fixtureData?.league?.season);
            const homeTeam = setFormFieldValue(fixtureData?.teams?.home);
            const awayTeam = setFormFieldValue(fixtureData?.teams?.away);
            const events = fixtureData?.events?.sort(byElapsedThenExtra) ?? [];
            const lineups = fixtureData?.lineups ?? [];
            const statistics = fixtureData?.statistics ?? [];

            const left = statistics.find((x) => x?.team?.id === homeTeam.id) ?? statistics[0];
            const right =
                statistics.find((x) => x?.team?.id === awayTeam.id && x?.team?.id !== left?.team?.id) ??
                statistics.find((x) => x?.team?.id !== left?.team?.id) ??
                statistics[1];

            const statisticPairs = {
                left: {
                    id: left?.team?.id,
                    name: homeTeam.name || left?.team?.name,
                    logo: left?.team?.logo || CDN_TEAM_LOGO(left?.team?.id),
                    map: makeMap(left?.statistics),
                    color: '#2563eb',
                },
                right: {
                    id: right?.team?.id,
                    name: awayTeam.name || right?.team?.name,
                    logo: right?.team?.logo || CDN_TEAM_LOGO(right?.team?.id),
                    map: makeMap(right?.statistics),
                    color: '#16a34a',
                },
            };

            return { ...state, leagueId: leagueId, season: season, fixture: fixtureData, homeTeam: homeTeam, awayTeam: awayTeam, events: events, lineups: lineups, statistics: statistics, statisticPairs: statisticPairs };
        case 'set_h2h':
            return { ...state, h2h: action.payload };
        case 'set_home_fixtures':
            return { ...state, homeFixtures: action.payload };
        case 'set_away_fixtures':
            return { ...state, awayFixtures: action.payload };
        case 'set_home_form':
            return { ...state, homeForm: action.payload };
        case 'set_away_form':
            return { ...state, awayForm: action.payload };
        case 'set_standings':
            return { ...state, standings: action.payload };
        case 'set_loading':
            return { ...state, isLoading: action.payload };
        case 'set_last_matches':
            return { ...state, lastMatches: action.payload };
        case 'reset_state':
            return initialState;
        default:
            return state;
    }
};

const makeMap = (stats = []) => {
    const m = new Map();
    stats.forEach((s) => m.set(normalizeLabel(s?.type), s?.value));
    return m;
};

const normalizeLabel = (t = "") =>
    String(t)
        .replace("Shots on target", "Shots on Goal")
        .replace("Shots off target", "Shots off Goal")
        .replace("Ball possession", "Ball Possession")
        .replace("Corner kicks", "Corner Kicks")
        .replace("Goalkeeper saves", "Goalkeeper Saves")
        .replace("Counter attacks", "Counter Attacks");

const byElapsedThenExtra = (a, b) => {
    const ea = a?.time?.elapsed ?? 0, eb = b?.time?.elapsed ?? 0;
    if (ea !== eb) return ea - eb;
    const xa = a?.time?.extra ?? 0, xb = b?.time?.extra ?? 0;
    return xa - xb;
};